module.exports = {"320205001":"东亭街道","320205002":"安镇街道","320205003":"东北塘街道","320205102":"羊尖镇","320205103":"鹅湖镇","320205105":"锡北镇","320205106":"东港镇","320205400":"无锡锡山开发区","320205401":"锡山台湾农民创业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320205.json
// module id = 777
// module chunks = 0